import Vue from 'vue'
import VueRouter from 'vue-router'
import { t } from './i18n'

Vue.use(VueRouter)

const routes = [
  { path: '/',             component: () => import('./views/Home.vue'),         meta: { titleKey: 'titles.home', bodyClass: 'page-home' } },
  { path: '/about',        component: () => import('./views/About.vue'),        meta: { titleKey: 'titles.about', bodyClass: 'page-about' } },
  { path: '/products',      component: () => import('./views/Products.vue'),     meta: { titleKey: 'titles.products', bodyClass: '' } },
  { path: '/products/item', component: () => import('./views/ProductItem.vue'), meta: { titleKey: 'titles.productItem', bodyClass: '' } },
  { path: '/applications', component: () => import('./views/Applications.vue'), meta: { titleKey: 'titles.applications', bodyClass: '' } },
  { path: '/quality',      component: () => import('./views/Quality.vue'),      meta: { titleKey: 'titles.quality', bodyClass: '' } },
  { path: '/news',         component: () => import('./views/News.vue'),         meta: { titleKey: 'titles.news', bodyClass: 'page-news' } },
  { path: '/contact',      component: () => import('./views/Contact.vue'),      meta: { titleKey: 'titles.contact', bodyClass: '' } },
  { path: '/privacy',      component: () => import('./views/Privacy.vue'),      meta: { titleKey: 'titles.privacy', bodyClass: '' } },
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return { ...savedPosition, behavior: 'auto' }
    }
    if (to.hash) {
      return { selector: to.hash, behavior: 'auto' }
    }
    // 路由切页使用瞬时滚动，避免从旧页面底部“被拉到顶部”的视觉拉扯
    return { x: 0, y: 0, behavior: 'auto' }
  }
})

// 切换页面时更新 title 和 body class
router.afterEach((to) => {
  document.title = t(to.meta.titleKey || 'titles.default')
  // 清除所有 page-* class，再设置当前页 class
  document.body.className = document.body.className
    .split(' ')
    .filter(c => !c.startsWith('page-'))
    .join(' ')
  if (to.meta.bodyClass) {
    document.body.classList.add(to.meta.bodyClass)
  }
})

export default router
